/** @format */
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Event, OtmId } from 'common-typescript/types';

@Component({
    selector: 'app-student-study-event-exceptions',
    templateUrl: './student-study-event-exceptions.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StudentStudyEventExceptionsComponent {
    @Input() irregularEvents: Event[];
    @Input() studyEventLocationIds: OtmId[];
    @Input() studyEventTeacherIds: OtmId[];
    @Input() language: string;
}
